module.exports = __webpack_public_path__ + "static/CL_Elastic-9114ef65af8ee23d546bacd3169b6d13.svg";